import { combineReducers } from 'redux'
import chat from './chat'
import geolocation from './geolocation'
import session from './session'

export default combineReducers({
  chat,
  session,
  geolocation
})



// WEBPACK FOOTER //
// ./reducers/index.js